import React, { useCallback, useState, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
// import BigNumber from 'bignumber.js'
import { Text } from 'rebass'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import { ButtonNewConfirmed } from '../../../components/Button'
import Loader from '../../../components/Loader'
import Row, { AutoRow } from '../../../components/Row'
// import ModalTitle from '../../../components/bakery/ModalTitle'

// hooks

const PetsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
`

const Label = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.bsText11};
  cursor: pointer;
  font-weight: 700;
  & > i {
    display: block;
    border: 2px solid ${({ theme }) => theme.bg5};
    border-radius: 50%;
    width: 18px;
    height: 18px;
  }
  span {
    margin-left: 5px;
  }
`
const Radio = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  &:checked ~ i {
    position: relative;
    border-color: #FF7A00;
    &:after {
      content: '';
      position: absolute;
      top: 1px;
      left: 1px;
      background: #FF7A00;
      border-radius: 50%;
      width: 12px;
      height: 12px;
    }
  }
  &:checked ~ span {
    color: ${({ theme }) => theme.primary1};
  }
`
const BtnRow = styled(Row)`
  margin: 0 auto;
  margin-top: 35px;
  width: 306px;
  font-size: 14px;
  justify-content: space-between;
  & > button {
    width: 145px;
    height: 32px;
    border-radius: 26px;
  }
`
interface AuditModalProps extends ModalProps {
  onConfirm: (fnc: any, ped: any) => void
  options: any[]
  defaultChecked?: boolean
  onSelectItem: (name: React.FormEvent) => void
  title: string,
}

const AuditModal: React.FC<AuditModalProps> = ({
  onDismiss,
  onConfirm,
  options,
  onSelectItem,
  title
}) => {
  const theme = useContext(ThemeContext)
  const [pendingTx, setPendingTx] = useState(false)
  const sureConfirm = useCallback(async () => {
    setPendingTx(true)
    onConfirm(onDismiss, setPendingTx)
  }, [onConfirm, onDismiss, setPendingTx])

  return (
    <Modal maxWidth={424} padding={'40px 59px 32px'}>
      {/* <ModalTitle text={title} /> */}
      <Text color={theme.bsText28} fontFamily="Roboto-Bold" fontSize="20px" textAlign="center">{title}</Text>
      <PetsWrapper>
        {
          options.map((d) => (
            <Label key={d.name} htmlFor={d.name}>
              <Radio
                type="radio"
                id={d.name}
                defaultChecked={d.defaultChecked}
                name='status'
                onChange={onSelectItem}
              />
              <i></i>
              <span>{d.name}</span>
            </Label>
          ))
        }
      </PetsWrapper>
      <BtnRow>
        <ButtonNewConfirmed
            style={{
              background: theme.bsBg36,
              border: '1px solid ' + theme.bsBorder9,
              color: theme.bsText36
            }}
            onClick={onDismiss}
          >Cancel</ButtonNewConfirmed>
          <ButtonNewConfirmed
            disabled={pendingTx}
            onClick={sureConfirm}
          >
            {pendingTx ? (
              <AutoRow gap="6px" justify="center">
                Pending <Loader stroke="white" />
              </AutoRow>
            ) : 'Confirm'}
          </ButtonNewConfirmed>
      </BtnRow>
    </Modal>
  )
}

export default AuditModal
